/**
 * Checks if the actual API version matches the expected min/max version.
 * Version should be in format "major.minor", like "0.1" or "2.4"
 * Returns true if actualVersion in [expectedMinVersion, expectedMaxVersion), so for "1.*" it should be [1.0, 2.0)
 */
export function isApiVersionMatch(actualVersion: string, expectedMinVersion: string, expectedMaxVersion?: string) {
  const [actualMajor = 0, actualMinor = 0] = actualVersion.split('.').map(Number)
  const [expectedMinMajor = 0, expectedMinMinor = 0] = expectedMinVersion.split('.').map(Number)
  const [expectedMaxMajor = 0, expectedMaxMinor = 0] = (expectedMaxVersion ?? '').split('.').map(Number)

  const isMatchMin =
    actualMajor > expectedMinMajor || (actualMajor === expectedMinMajor && actualMinor >= expectedMinMinor)
  const isMatchMax =
    !expectedMaxVersion ||
    actualMajor < expectedMaxMajor ||
    (actualMajor === expectedMaxMajor && actualMinor < expectedMaxMinor)

  return isMatchMin && isMatchMax
}
